<template>
  <div class="row">
    <div class="theme-list col-lg-2">
      <span class="control-label col-sm-10">{{ $t('ct-theme') }}</span>
      <div class="theme-label"
           v-for="theme in themes"
           :key="theme.id"
           :class="{'selected': selectedTheme && theme === selectedTheme}"
           :style="{backgroundColor: theme.form,  color: theme.textColor}"
           @click="select(theme)"
      >
        <span class="theme-title">{{ theme.name }}</span>
      </div>
    </div>
    <div class="list-container col" :style="{backgroundColor: selectedTheme.containerBackground}">
      <div class="theme-container col-lg-6 mx-auto" v-if="selectedTheme">
        <div class="baloon-container" v-if="config.texts.baloon" :style="{color: selectedTheme.buttonTextColor}">
          <div class="baloon" :style="{backgroundColor: selectedTheme.buttons}">
            {{ config.texts.baloon }}
          </div>
          <span class="baloon-after" :style="{borderTopColor: selectedTheme.buttons}"></span>
        </div>
        <div class="tabs" :style="{color: selectedTheme.textColor}">
          <div class="tab tab-left active" :style="{backgroundColor: selectedTheme.form}">
            <div class="tab-step" :style="{backgroundColor: selectedTheme.tabBulletActive}">
              1
            </div>
            <div class="step-description">
              <span class="tab-title">{{ config.texts.step1_title }}</span>
              <span>{{ config.texts.step1_text }}</span>
            </div>
          </div>
          <div class="tab tab-right" :style="{backgroundColor: selectedTheme.formSecondary}">
            <div class="tab-step" :style="{backgroundColor: selectedTheme.tabBullet}">
              2
            </div>
            <div class="step-description">
              <span class="tab-title">{{ config.texts.step2_title }}</span>
              <span>{{ config.texts.step2_text }}</span>
            </div>
          </div>
        </div>
        <div class="theme-form" :style="{backgroundColor: selectedTheme.form, color: selectedTheme.textColor}">
          <div class="theme-input filled" :style="{borderColor: selectedTheme.borderColor}">
            {{ $t('ct-checkout-filled-input') }}
          </div>
          <div class="theme-input" :style="{borderColor: selectedTheme.borderColor}">
            {{ $t('ct-checkout-empty-input') }}
          </div>

          <span class="section-title"><span>{{ $t('ct-checkout-shipping') }}</span> <span class="section-title-line"></span></span>
          <div class="theme-input" :style="{borderColor: selectedTheme.borderColor}">
            {{ $t('ct-checkout-empty-input') }}
          </div>
          <div class="theme-input" :style="{borderColor: selectedTheme.borderColor}">
            {{ $t('ct-checkout-empty-input') }}
          </div>

          <div class="theme-button" :style="{backgroundColor: selectedTheme.buttons, color: selectedTheme.buttonTextColor}">
            <span class="button-main-text">{{config.texts.buy_button}}</span>
            <span>{{config.texts.buy_button_sub}}</span>
          </div>
          <p>{{config.texts.bottom_info}}</p>
        </div>
      </div>
      <div class="theme-container col-lg-6 mx-auto" v-if="selectedTheme">
        <div class="baloon-container" v-if="config.texts.baloon" :style="{color: selectedTheme.buttonTextColor}">
          <div class="baloon" :style="{backgroundColor: selectedTheme.buttons}">
            {{ config.texts.baloon }}
          </div>
          <span class="baloon-after" :style="{borderTopColor: selectedTheme.buttons}"></span>
        </div>
        <div class="tabs" :style="{color: selectedTheme.textColor}">
          <div class="tab tab-left" :style="{backgroundColor: selectedTheme.formSecondary}">
            <div class="tab-step" :style="{backgroundColor: selectedTheme.tabBullet}">
              1
            </div>
            <div class="step-description">
              <span class="tab-title">{{ config.texts.step1_title }}</span>
              <span>{{ config.texts.step1_text }}</span>
            </div>
          </div>
          <div class="tab tab-right active" :style="{backgroundColor: selectedTheme.form}">
            <div class="tab-step" :style="{backgroundColor: selectedTheme.tabBulletActive}">
              2
            </div>
            <div class="step-description">
              <span class="tab-title">{{ config.texts.step2_title }}</span>
              <span>{{ config.texts.step2_text }}</span>
            </div>
          </div>
        </div>
        <div class="theme-form" :style="{backgroundColor: selectedTheme.form, color: selectedTheme.textColor}">
          <div>
            <div class="overview-column-title" :style="{borderColor: selectedTheme.borderColor}">
              <span>{{ $t('ct-item') }}</span><span>{{ $t('ct-price') }}</span>
            </div>
            <div class="overview-options-list">
              <label class="overview-option offer-spotlight" :style="{backgroundColor: selectedTheme.buttons, color: selectedTheme.buttonTextColor}">
                <input type="checkbox" value="mdvNyEa28uhUYmZD">
                <span class="item-name">Test item 1</span>
                <span>$10.00</span>
              </label>
              <label class="overview-option">
                <input type="checkbox" disabled="disabled" value="mRmHiZuj9L9vU7EK">
                <span class="item-name">Test default</span>
                <span>$0.00</span>
              </label>
            </div>
          </div>

          <div class="theme-payment-form" :style="{backgroundColor: selectedTheme.paymentBackground}">
            <div class="theme-input filled">
              This is a payment input
            </div>

            <div class="theme-input">
              0000 0000 0000 0000 MM/YY CVC
            </div>
          </div>

          <div>
            <div class="overview-column-title" :style="{borderColor: selectedTheme.borderColor}">
              <span>{{ $t('ct-item') }}</span>
              <span>{{ $t('ct-amount') }}</span>
            </div>
            <div class="overview-options-list">
              <div class="overview-option"><span>Test product name</span>
                <span>$15.99</span>
              </div>
              <div class="overview-option">
                <span>VAT for your country</span>
                <span>$3.20</span>
              </div>
              <div class="overview-option"><span>Discount (12%)</span> <span>$1.85</span></div>
            </div>
            <div class="overview-column-title total" :style="{borderColor: selectedTheme.borderColor}">
              <span>Order Total:</span>
              <span>$15.99</span>
            </div>
          </div>

          <div class="theme-button" :style="{backgroundColor: selectedTheme.buttons, color: selectedTheme.buttonTextColor}">
            <span class="button-main-text">{{config.texts.pay_button}}</span>
          </div>
          <p style="text-align: center;">{{ config.texts.payment_bottom_info }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['config', 'sellable'],
  data: vm => ({
    selectedTheme: null,
    themes: [
      {
        id: 'blue-light',
        name: 'Blue Light',
        form: '#4285F4',
        textColor: '#fff',
        buttonTextColor: '#fff',
        formSecondary: '#14469b',
        tabBullet: '#123a78',
        tabBulletActive: '#366fc4',
        buttons: '#14C51B',
        containerBackground: '#f6f7f8'
      },
      {
        id: 'blue-deep',
        name: 'Blue deep',
        form: '#4314AB',
        textColor: '#fdfdfd',
        buttonTextColor: '#fff',
        formSecondary: '#28184d',
        tabBullet: '#21173f',
        tabBulletActive: '#371c8f',
        buttons: '#FF7A00',
        containerBackground: '#f6f7f8'
      },
      {
        id: 'orange',
        name: 'Orange',
        form: '#FF7A00',
        textColor: '#fff',
        buttonTextColor: '#fff',
        formSecondary: '#f29843',
        tabBullet: '#d35e2d',
        tabBulletActive: '#be5e05',
        buttons: '#14C51B',
        containerBackground: '#f6f7f8'
      },
      {
        id: 'black',
        name: 'Black',
        form: '#0b0b0b',
        textColor: '#fff',
        buttonTextColor: '#fff',
        formSecondary: '#313032',
        tabBullet: '#27292a',
        tabBulletActive: '#0d1519',
        buttons: '#1D6AFF',
        containerBackground: '#f6f7f8'
      },
      {
        id: 'white',
        name: 'White',
        form: '#FFFFFF',
        textColor: '#123241',
        buttonTextColor: '#fff',
        formSecondary: '#f2f2f2',
        tabBullet: '#b7b9b9',
        tabBulletActive: '#bec0c0',
        buttons: '#4184f2',
        borderColor: '#d7d7d7',
        containerBackground: '#333',
        paymentBackground: '#f2f2f2'
      }
    ]
  }),
  computed: {
    selectedTheme() {
      return this.config ? this.config.theme : null;
    }
  },
  methods: {
    select(theme) {
      this.selectedTheme = theme;
      this.config.theme = theme;
    }
  },

  mounted() {
    this.select(
      this.themes.find(t => t.id === (this.config.theme.id || 'blue-light'))
    );
  }
};
</script>

<style src="./twostep.css" scoped />



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/Form/ThemePreviewTwoStep.vue